import {requestUrl, requestHeaders, requestOptions} from '../../graphQLClient.js'
import Vue from 'vue';
import {isEmptyObject, isExists} from "@/helpers/check_variable_types";

const CSV = 'CSV';

export default {

  getSummaryDataFromAPI({dispatch, state}, filtersData)
  {
      return new Promise(function (resolve, reject) {
          return resolve({});
      });
  },

  getReportDataFromAPI({dispatch, state}, filters){

    if (filters.reportFilters.sites.length === 0 || filters.reportFilters.sources.length === 0)
    {
      return new Promise(function (resolve, reject) {
        return resolve({});
      });
    }

    let requestQueryBody = {
      operationName: null,
      query: null,
      variables: {}
    };

    let filtersDeclaration = [];
    let filtersSchema = [];
    let columns = '';
    let limit = 10;

    filtersDeclaration.push('$orderByField: String!');
    filtersDeclaration.push('$orderByDirection: String!');
    filtersDeclaration.push('$paginationCursorBefore: String!');
    filtersDeclaration.push('$paginationCursorAfter: String!');

    requestQueryBody.variables.paginationCursorBefore = '';
    requestQueryBody.variables.paginationCursorAfter = '';
    requestQueryBody.variables.orderByField = 'boughtClicks';
    requestQueryBody.variables.orderByDirection = 'DESC';

    requestQueryBody.variables.first = null;
    requestQueryBody.variables.last = null;
    filtersDeclaration.push('$first: Int');
    filtersDeclaration.push('$last: Int');

    if (filters.format !== undefined)
    {
        let columnsData = filtersData.columns;
        let sortingData = filtersData.sorting;
        let filtersList = filtersData.reportFilters;
        let paginationData = filtersData.paginationData;

        if (
            isEmptyObject(filtersList) ||
            !isExists(filtersList.filters.siteId) ||
            !isExists(filtersList.filters.sourceId) ||
            filtersList.filters.siteId.length === 0 ||
            filtersList.filters.sourceId.length === 0
        )
        {
            return new Promise(function (resolve, reject) {
                return resolve({});
            });
        }

        let requestQueryBody = {
            operationName: null,
            query: null,
            variables: {}
        };

        let filtersDeclaration = [];
        let filtersSchema = [];
        let columns = '';
        let limit = 10;

        // filtersDeclaration.push('$orderByField: String!');
        // filtersDeclaration.push('$orderByDirection: String!');
        filtersDeclaration.push('$paginationCursorBefore: String!');
        filtersDeclaration.push('$paginationCursorAfter: String!');
        filtersDeclaration.push('$sort: [Ordering]');

        requestQueryBody.variables.paginationCursorBefore = '';
        requestQueryBody.variables.paginationCursorAfter = '';
        // requestQueryBody.variables.orderByField = 'boughtClicks';
        // requestQueryBody.variables.orderByDirection = 'DESC';

        requestQueryBody.variables.first = null;
        requestQueryBody.variables.last = null;
        filtersDeclaration.push('$first: Int');
        filtersDeclaration.push('$last: Int');

        if (isExists(filtersList.filters.format))
        {
            limit = null;
            requestQueryBody.variables.reportFormat = filtersList.filters.format;
            filtersDeclaration.push('$reportFormat: ReportFormat');
            filtersSchema.push('reportFormat: $reportFormat');
        }

        if (isExists(columnsData) && columnsData.length)
        {
            let realColumns = columnsData.filter(column => column.virtualField !== true);
            realColumns = realColumns.filter(column => column.visible === true);

            let mainColumns = realColumns.filter(column => column.isMetricValue === false);
            let metricsColumns = realColumns.filter(column => column.isMetricValue === true);

            mainColumns.push('siteId');
            mainColumns.push('sourceId');

            columns = mainColumns.map(column => column.field).join('\n');
            columns = columns + '\n' + 'metrics {' + metricsColumns.map(column => column.field).join('\n') + '\n' + 'dateRange';

            if (filtersList.filters.dateComparisonStatus === false)
            {
                let feedsColumns = ['feedId', 'soldClicks', 'revenue', 'rpc'];
                let feedColumn = 'feeds {' + feedsColumns.map(column => column).join('\n') + '}';

                columns += '\n' + feedColumn;
            }

            columns += '\n}';
        }

        if (isExists(filtersList.filters))
        {
            if (
                isExists(filtersList.filters.dateRange.startDateB) &&
                isExists(filtersList.filters.dateRange.endDateB)
            )
            {
                requestQueryBody.variables.dateRangesIn = [[filtersList.filters.dateRange.startDate.clone().format("YYYY-MM-DD"), filtersList.filters.dateRange.endDate.clone().format("YYYY-MM-DD")], [filtersList.filters.dateRange.startDateB.format("YYYY-MM-DD"), filtersList.filters.dateRange.endDateB.clone().format("YYYY-MM-DD")]];
                filtersDeclaration.push('$dateRangesIn: [[String!]]');
                filtersSchema.push('dateRangesIn: $dateRangesIn');
            }
            else if (isExists(filtersList.filters.dateRange.startDate) && isExists(filtersList.filters.dateRange.endDate))
            {
                requestQueryBody.variables.dateInRange = [filtersList.filters.dateRange.startDate.clone().format("YYYY-MM-DD"), filtersList.filters.dateRange.endDate.clone().format("YYYY-MM-DD")];
                filtersDeclaration.push('$dateInRange: [String!]');
                filtersSchema.push('dateInRange: $dateInRange');
            }

            if (isExists(paginationData) && (filtersList.filters.format === undefined || filtersList.filters.format != CSV))
            {
                limit = paginationData.limit;
            }

            if (isExists(filtersList.filters.siteId))
            {
                requestQueryBody.variables.siteId = filtersList.filters.siteId;
                filtersDeclaration.push('$siteId: [Int!]');
                filtersSchema.push('siteIdIn: $siteId');
            }

            if (isExists(filtersList.filters.sourceId))
            {
                requestQueryBody.variables.sourceId = filtersList.filters.sourceId;
                filtersDeclaration.push('$sourceId: [Int!]');
                filtersSchema.push('sourceIdIn: $sourceId');
            }

            if (isExists(filtersList.filters.deviceId))
            {
                requestQueryBody.variables.deviceIdIn = filtersList.filters.deviceId;
                filtersDeclaration.push('$deviceIdIn: [Int!]');
                filtersSchema.push('deviceIdIn: $deviceIdIn');
            }

            if (isExists(filtersList.search))
            {
                requestQueryBody.variables.searchPhrase = filtersList.search;
                filtersDeclaration.push('$searchPhrase: String!');
                filtersSchema.push('searchPhrase: $searchPhrase');
            }

            if (isExists(filtersList.advancedFilters))
            {
                if (isExists(filtersList.advancedFilters.boughtClicksGte) && filtersList.advancedFilters.boughtClicksGte > 0)
                {
                    requestQueryBody.variables.boughtClicksGte = parseInt(filtersList.advancedFilters.boughtClicksGte);
                    filtersDeclaration.push('$boughtClicksGte: Int');
                    filtersSchema.push('boughtClicksGte: $boughtClicksGte');
                }

                if (isExists(filtersList.advancedFilters.soldClicksGte) && filtersList.advancedFilters.soldClicksGte > 0)
                {
                    requestQueryBody.variables.soldClicksGte = parseInt(filtersList.advancedFilters.soldClicks);
                    filtersDeclaration.push('$soldClicksGte: Int');
                    filtersSchema.push('soldClicksGte: $soldClicksGte');
                }

                if (isExists(filtersList.advancedFilters.profitGte) && filtersList.advancedFilters.profitGte > 0)
                {
                    requestQueryBody.variables.profitGte = parseFloat(filtersList.advancedFilters.profitGte);
                    filtersDeclaration.push('$profitGte: Int');
                    filtersSchema.push('profitGte: $profitGte');
                }

                if (
                    isExists(filtersList.advancedFilters.rpcInRange) &&
                    isExists(filtersList.advancedFilters.rpcInRange.min) &&
                    isExists(filtersList.advancedFilters.rpcInRange.max) &&
                    (filtersList.advancedFilters.rpcInRange.max > 0 || filtersList.advancedFilters.rpcInRange.min > 0)
                )
                {
                    requestQueryBody.variables.rpcInRange = [parseFloat(filtersList.advancedFilters.rpcInRange.min), parseFloat(filtersList.advancedFilters.rpcInRange.max)];
                    filtersDeclaration.push('$rpcInRange: [Int!]');
                    filtersSchema.push('rpcInRange: $rpcInRange');
                }

                if (
                    isExists(filtersList.advancedFilters.opCtrInRange) &&
                    isExists(filtersList.advancedFilters.opCtrInRange.min) &&
                    isExists(filtersList.advancedFilters.opCtrInRange.max) &&
                    (filtersList.advancedFilters.opCtrInRange.max > 0 || filtersList.advancedFilters.opCtrInRange.min > 0)
                )
                {
                    requestQueryBody.variables.opCtrInRange = [parseFloat(filtersList.advancedFilters.opCtrInRange.min), parseFloat(filtersList.advancedFilters.opCtrInRange.max)];
                    filtersDeclaration.push('$opCtrInRange: [Int!]');
                    filtersSchema.push('opCtrInRange: $opCtrInRange');
                }

                if (isExists(filtersList.advancedFilters.kwrNumGte) && filtersList.advancedFilters.kwrNumGte > 0)
                {
                    requestQueryBody.variables.kwrNumGte = parseInt(filtersList.advancedFilters.kwrNumGte);
                    filtersDeclaration.push('$kwrNumGte: Int');
                    filtersSchema.push('kwrNumGte: $kwrNumGte');
                }

                if (isExists(filtersList.advancedFilters.adGroupStatusIn))
                {
                    requestQueryBody.variables.adGroupStatusIn = filtersList.advancedFilters.adGroupStatusIn;
                    filtersDeclaration.push('$adGroupStatusIn: [AdGroupStatus!]');
                    filtersSchema.push('adGroupStatusIn: $adGroupStatusIn');
                }

                if (isExists(filtersList.advancedFilters.adGroupLabelsContainsAny))
                {
                    requestQueryBody.variables.adGroupLabelsContainsAny = filtersList.advancedFilters.adGroupLabelsContainsAny;
                    filtersDeclaration.push('$adGroupLabelsContainsAny: [String!]');
                    filtersSchema.push('adGroupLabelsContainsAny: $adGroupLabelsContainsAny');
                }

                if (isExists(filtersList.advancedFilters.campaignName))
                {
                    requestQueryBody.variables.campaignName = filtersList.advancedFilters.campaignName;
                    filtersDeclaration.push('$campaignName: String');
                    filtersSchema.push('campaignName: $campaignName');
                }

                if (isExists(filtersList.advancedFilters.adGroupName))
                {
                    requestQueryBody.variables.adGroupName = filtersList.advancedFilters.adGroupName;
                    filtersDeclaration.push('$adGroupName: String');
                    filtersSchema.push('adGroupName: $adGroupName');
                }

                if (filtersList.advancedFilters.groupByDate !== null && filtersList.advancedFilters.groupByDate !== undefined &&
                    filtersList.advancedFilters.groupByDate === true && filtersList.advancedFilters.dateComparisonStatus !== true)
                {
                    requestQueryBody.variables.groupByDate = 'DATE';
                    filtersDeclaration.push('$groupByDate: AdgroupReportGroupByDate');
                    filtersSchema.push('groupByDate: $groupByDate');
                }
            }

            let sort = [];
            if (filtersList.sort && filtersList.sort.length)
            {
                sort = filtersList.sort.map(function(item){

                    return {
                        sort: item.field,
                        direction: item.direction
                    }

                    /*
                    [
                                         {sort: $orderByField, direction: $orderByDirection}
                                     ]
                     */
                });

                // requestQueryBody.variables.orderByField = sortingData.sortColumn;
                // requestQueryBody.variables.orderByDirection = sortingData.sortDirection;
            }

            requestQueryBody.variables.sort = sort;

            if (paginationData.pagination)
            {
                if (typeof paginationData.pagination.direction !== 'undefined' && paginationData.pagination.direction == 'after')
                {
                    requestQueryBody.variables.paginationCursorAfter = paginationData.pagination.cursor;
                    requestQueryBody.variables.first = limit;
                }
                else if(typeof paginationData.pagination !== 'undefined' && paginationData.pagination.direction == 'before')
                {
                    requestQueryBody.variables.paginationCursorBefore = paginationData.pagination.cursor;
                    requestQueryBody.variables.last = limit;
                }
                else
                {
                    requestQueryBody.variables.first = limit;
                }
            }
        }

        var format = null;
        if (filtersList.filters !== undefined && filtersList.filters.format !== undefined)
        {
            format = filtersList.filters.format;
        }

        requestQueryBody.query = getReportRequestBody(columns, filtersDeclaration, filtersSchema, format);

        let options = Object.assign({
            body: JSON.stringify(requestQueryBody),
            headers: requestHeaders
        }, requestOptions);

        return fetch(requestUrl, options).then(function(response){
            if (format == CSV)
            {
                return response.blob();
            }
            else
            {
                return response.json();
            }
        }).then(function(data){
            if (format == CSV)
            {
                return data;
            }
            else
            {
                return data.data;
            }
        }).catch(function(reason){
            Vue.$log.warn(reason);

            Vue.prototype.$notification.setPosition('topRight')
                .setCloseStatus(true)
                .setCloseOnClick(true)
                .setCloseOnEscape(true)
                .setTimeout(false)
                .setSettings();

            Vue.prototype.$notification.showWarning('Warning!', 'Can not get data');

            return [];
        });
    }
    },
    

    getReportChartsData({dispatch, state}, filters){

        if (filters.reportFilters.sites.length === 0 || filters.reportFilters.sources.length === 0)
        {
            return new Promise(function (resolve, reject) {
                return resolve({});
            });
        }

        let requestQueryBody = {
            operationName: null,
            query: null,
            variables: {}
        };

        let filtersDeclaration = [];
        let filtersSchema = [];
        let columns = '';
        let limit = 10;

        filtersDeclaration.push('$orderByField: String!');
        filtersDeclaration.push('$orderByDirection: String!');
        filtersDeclaration.push('$paginationCursorBefore: String!');
        filtersDeclaration.push('$paginationCursorAfter: String!');

        requestQueryBody.variables.paginationCursorBefore = '';
        requestQueryBody.variables.paginationCursorAfter = '';
        requestQueryBody.variables.orderByField = 'dateRange';
        requestQueryBody.variables.orderByDirection = 'ASC';

        requestQueryBody.variables.first = limit;
        requestQueryBody.variables.last = null;

        filtersDeclaration.push('$first: Int');
        filtersDeclaration.push('$last: Int');

        if (filters !== undefined)
        {
            if (filters.format !== undefined)
            {
                limit = null;
                requestQueryBody.variables.reportFormat = filters.format;
                filtersDeclaration.push('$reportFormat: ReportFormat');
                filtersSchema.push('reportFormat: $reportFormat');
            }

            if (filters.columns !== undefined && filters.columns.length)
            {
                columns = 'adGroupName' + '\n' + 'metrics {' + filters.columns.map(column => column.field).join('\n') + '\n' + 'dateRange' + '\n}';
            }

            if (filters.dates !== null)
            {
                requestQueryBody.variables.dateRangesIn = filters.dates;
                filtersDeclaration.push('$dateRangesIn: [[String!]]');
                filtersSchema.push('dateRangesIn: $dateRangesIn');

                requestQueryBody.variables.first = filters.dates.length;
            }

            if (filters.siteId !== null)
            {
                requestQueryBody.variables.siteId = [filters.siteId];
                filtersDeclaration.push('$siteId: [Int!]');
                filtersSchema.push('siteIdIn: $siteId');
            }

            if (filters.sourceId !== null)
            {
                requestQueryBody.variables.sourceId = [filters.sourceId];
                filtersDeclaration.push('$sourceId: [Int!]');
                filtersSchema.push('sourceIdIn: $sourceId');
            }

            if (filters.adGroupName !== null)
            {
                requestQueryBody.variables.adGroupName = filters.adGroupName;
                filtersDeclaration.push('$adGroupName: String!');
                filtersSchema.push('adGroupName: $adGroupName');
            }

            if (filters.campaignName !== null)
            {
                requestQueryBody.variables.campaignName = filters.campaignName;
                filtersDeclaration.push('$campaignName: String!');
                filtersSchema.push('campaignName: $campaignName');
            }
        }

        var format = null;
        if (filters !== undefined && filters.format !== undefined)
        {
            format = filters.format;
        }

        requestQueryBody.query = getReportRequestBody(columns, filtersDeclaration, filtersSchema, format);

        let options = Object.assign({
            body: JSON.stringify(requestQueryBody),
            headers: requestHeaders
        }, requestOptions);

        return fetch(requestUrl, options).then(function(response){
            if (format == CSV)
            {
                return response.blob();
            }
            else
            {
                return response.json();
            }
        }).then(function(data){

            if (format == CSV)
            {
                return data;
            }
            else
            {
                return data.data;
            }

        }).catch(function(reason){
            Vue.$log.warn(reason);
            return [];
        });
    },

    getSummaryReportChartsData({dispatch, state}, filters){

        if (filters.reportFilters.sites.length === 0 || filters.reportFilters.sources.length === 0)
        {
            return new Promise(function (resolve, reject) {
                return resolve({});
            });
        }

        let requestQueryBody = {
            operationName: null,
            query: null,
            variables: {}
        };

        let filtersDeclaration = [];
        let filtersSchema = [];
        let limit = 30;

        filtersDeclaration.push('$orderByField: String!');
        filtersDeclaration.push('$orderByDirection: String!');
        filtersDeclaration.push('$paginationCursorBefore: String!');
        filtersDeclaration.push('$paginationCursorAfter: String!');
        filtersDeclaration.push('$groupBy: [SummaryGroupByFields!]');

        requestQueryBody.variables.paginationCursorBefore = '';
        requestQueryBody.variables.paginationCursorAfter = '';
        requestQueryBody.variables.orderByField = 'date';
        requestQueryBody.variables.orderByDirection = 'ASC';
        requestQueryBody.variables.groupBy = ['Date'];

        requestQueryBody.variables.first = limit;
        requestQueryBody.variables.last = null;
        filtersDeclaration.push('$first: Int');
        filtersDeclaration.push('$last: Int');

        if (filters.reportFilters !== undefined)
        {
            if (filters.reportFilters.dates !== null)
            {
                requestQueryBody.variables.dateIn = filters.reportFilters.dates;
                filtersDeclaration.push('$dateIn: [String!]');
                filtersSchema.push('dateIn: $dateIn');

                limit = filters.reportFilters.dates.length;
            }

            if (filters.reportFilters.sites !== null && filters.reportFilters.sites.length > 0)
            {
                requestQueryBody.variables.siteId = filters.reportFilters.sites;
                filtersDeclaration.push('$siteId: [Int!]');
                filtersSchema.push('siteIdIn: $siteId');
            }

            if (filters.reportFilters.sources !== null && filters.reportFilters.sources.length > 0)
            {
                requestQueryBody.variables.sourceId = filters.reportFilters.sources;
                filtersDeclaration.push('$sourceId: [Int!]');
                filtersSchema.push('sourceIdIn: $sourceId');
            }

            if (filters.reportFilters.devices !== null && filters.reportFilters.devices.length > 0)
            {
                requestQueryBody.variables.deviceIdIn = filters.reportFilters.devices;
                filtersDeclaration.push('$deviceIdIn: [Int!]');
                filtersSchema.push('deviceIdIn: $deviceIdIn');
            }

            if (filters.reportFilters.advancedFilters !== null)
            {
                if (filters.reportFilters.advancedFilters.boughtClicksGte !== null && filters.reportFilters.advancedFilters.boughtClicksGte > 0)
                {
                    requestQueryBody.variables.boughtClicksGte = parseInt(filters.reportFilters.advancedFilters.boughtClicksGte);
                    filtersDeclaration.push('$boughtClicksGte: Int');
                    filtersSchema.push('boughtClicksGte: $boughtClicksGte');
                }

                if (filters.reportFilters.advancedFilters.soldClicksGte !== null && filters.reportFilters.advancedFilters.soldClicksGte > 0)
                {
                    requestQueryBody.variables.soldClicksGte = parseInt(filters.reportFilters.advancedFilters.soldClicks);
                    filtersDeclaration.push('$soldClicksGte: Int');
                    filtersSchema.push('soldClicksGte: $soldClicksGte');
                }

                if (filters.reportFilters.advancedFilters.profitGte !== null && filters.reportFilters.advancedFilters.profitGte > 0)
                {
                    requestQueryBody.variables.profitGte = parseFloat(filters.reportFilters.advancedFilters.profitGte);
                    filtersDeclaration.push('$profitGte: Int');
                    filtersSchema.push('profitGte: $profitGte');
                }

                if (
                    filters.reportFilters.advancedFilters.rpcInRange !== undefined && filters.reportFilters.advancedFilters.rpcInRange.min !== null && filters.reportFilters.advancedFilters.rpcInRange.max !== null &&
                    (filters.reportFilters.advancedFilters.rpcInRange.max > 0 || filters.reportFilters.advancedFilters.rpcInRange.min > 0)
                )
                {
                    requestQueryBody.variables.rpcInRange = [parseFloat(filters.reportFilters.advancedFilters.rpcInRange.min), parseFloat(filters.reportFilters.advancedFilters.rpcInRange.max)];
                    filtersDeclaration.push('$rpcInRange: [Int!]');
                    filtersSchema.push('rpcInRange: $rpcInRange');
                }

                if (
                    filters.reportFilters.advancedFilters.opCtrInRange !== undefined && filters.reportFilters.advancedFilters.opCtrInRange.min !== null && filters.reportFilters.advancedFilters.opCtrInRange.max !== null &&
                    (filters.reportFilters.advancedFilters.opCtrInRange.max > 0 || filters.reportFilters.advancedFilters.opCtrInRange.min > 0))
                {
                    requestQueryBody.variables.opCtrInRange = [parseFloat(filters.reportFilters.advancedFilters.opCtrInRange.min), parseFloat(filters.reportFilters.advancedFilters.opCtrInRange.max)];
                    filtersDeclaration.push('$opCtrInRange: [Int!]');
                    filtersSchema.push('opCtrInRange: $opCtrInRange');
                }
            }
        }
        requestQueryBody.query = getSummaryReportRequestBody(filtersDeclaration, filtersSchema);

        let options = Object.assign({
            body: JSON.stringify(requestQueryBody),
            headers: requestHeaders
        }, requestOptions);

        return fetch(requestUrl, options).then(function(response){
            return response.json();
        }).then(function(data){
            return data.data;
        }).catch(function(reason){
            Vue.$log.warn(reason);
            return [];
        });
    },
};

function getReportRequestBody(columns, filtersDeclaration, filters, format = null)
{
    let query = '';
    let defaultColumns = [];

    if (format == CSV)
    {
        defaultColumns = ['linkTypeUid', 'targetUrl', 'finalUrl'];
    }
    else
    {
        defaultColumns = ['siteId', 'sourceId', 'adGroupId', 'linkTypeUid', 'targetUrl', 'finalUrl'];
    }

    query = `query adgroupReport(` + filtersDeclaration.join(', ') + `
                               ){
                                  report: adgroupReport(first: $first,
                                    last: $last, 
                                    filters: {
                                        ` + filters.join(', ') +
        `                         }, 
                                    after: $paginationCursorAfter,
                                    before: $paginationCursorBefore,
                                    orderBy: [
                                        {sort: $orderByField, direction: $orderByDirection}
                                    ]) 
                                    {
                                      totalCount,
                                      pageInfo {
                                        hasNextPage
                                        hasPreviousPage
                                        startCursor
                                        endCursor
                                      }
                                      edges {
                                        cursor
                                        node {
                                        ` + columns + `
                                        ` + defaultColumns.join('\n') + ` 
                                        }
                                    }
                                  }
                              }
                            `;

    return query;
}

function getSummaryReportRequestBody(filtersDeclaration, filters)
{
    let query = `query summaryReport(` + filtersDeclaration.join(', ') + `
                               ){
                                  report: summaryReport(first: $first,
                                    last: $last, 
                                    filters: {
                                        ` + filters.join(', ') +
        `                         }, 
                                    after: $paginationCursorAfter,
                                    before: $paginationCursorBefore,
                                    groupBy: $groupBy,
                                    orderBy: [
                                        {sort: $orderByField, direction: $orderByDirection}
                                    ]) 
                                    {
                                      totalCount,
                                      pageInfo {
                                        hasNextPage
                                        hasPreviousPage
                                        startCursor
                                        endCursor
                                      }
                                      edges {
                                        cursor
                                        node {
                                            date
                                            siteId
                                            sourceId
                                            siteName
                                            sourceName
                                            metrics {
                                              dateRange
                                              boughtClicks
                                              adCtr
                                              cost
                                              cpc
                                              soldClicks
                                              revenue
                                              opCtr
                                              rps
                                              rpc
                                              profit
                                            }
                                        }
                                    }
                                  }
                              }
                            `;

    return query;
}



// WEBPACK FOOTER //
// ./src/store/modules/sellingPartnersReport/actions.js